export default __webpack_public_path__ + "static/media/Group1268-yono.8d81dc49.png";